const UNSUPPORTED_CHARS = /[.*+?^${}()|[\]\\]/g;
const EMPTY_CHAR = '\\$&';

export default (search?: string) =>
  search?.replace(UNSUPPORTED_CHARS, EMPTY_CHAR);
